import { render, staticRenderFns } from "./EditIngamePassword.vue?vue&type=template&id=3ac83d5d&scoped=true&"
import script from "./EditIngamePassword.vue?vue&type=script&lang=ts&"
export * from "./EditIngamePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac83d5d",
  null
  
)

export default component.exports